import { message } from 'antd';
import { queryCustomInfo } from '@api/crm/custom';
import PageAdd from './PageAdd';

class Edit extends PageAdd {
  componentWillMount() {}

  componentDidMount() {
    const { uuid } = this.props.routeParams;
    this.loadData(uuid);
  }

  loadData = uuid => {
    const context = this;
    queryCustomInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        context.setState({ customInfo: res.data });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default Edit;



// WEBPACK FOOTER //
// ./src/components/custom/base/PageEdit.js